import React, { Component } from 'react';
import Loading from '../shared/Loading';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router-dom';

import TorontoDashboard from './TorontoDashboard';
import NycDashboard from './NycDashboard';
// import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const query = gql`
  query geoLocation {
    currentUser {
      id
      email
      operatingCity
    }
    locateIp
  }
`;

class GeoRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { loggedIn } = this.props;
    return (
      <Query query={query}>
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          if (data.locateIp === 'US' || (loggedIn && data.currentUser.operatingCity === 'new_york')) {
            return <NycDashboard {...this.props} />;
          }
          return <TorontoDashboard {...this.props} />;
        }}
      </Query>
    );
  }
}

export default GeoRouter;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/index.js